export default "__VITE_ASSET__579b65c3__"